import { api } from '@/lib/api-manager'
import type { Kpi } from '@/types/kpi/kpi'
import type { KpiFilters } from '@/types/kpi/kpi-filters'

export async function getRequestsKpis(
  filter: Partial<KpiFilters>
): Promise<Kpi> {
  const result = await api.get('v1/requests/kpis', { params: filter })
  return result.data.data
}
